import axios from 'axios'
import React, { useState, useEffect, useMemo, Fragment, useRef } from 'react'

import { FormControl, InputLabel, Input, FormHelperText, Alert, Divider, listItemClasses } from '@mui/material'
import WebService from '@util/webService'
import { encodeParams, findCode, getAction, printVariable, comma } from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux'
import ManagerBillPartPay from '@pages/manager/manager-bill.part.pay'
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField, withStyles, InputBase } from '@mui/material'
import { styled, alpha } from '@mui/material/styles'
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton'
import useSnackbar from '@hooks/useSnackbar'
import MyTableHead from '@components/MyTableHead'
import useIndicator from '@hooks/useIndicator'
import Indicator from '@components/Indicator'
import MyDialog from '@components/MyDialog'
import useForm from '@hooks/useForm'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
// pagination
import { useTheme } from '@mui/material/styles'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import LastPageIcon from '@mui/icons-material/LastPage'
import ControlPointIcon from '@mui/icons-material/ControlPoint'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import Paper from '@mui/material/Paper'
import moment from 'moment'
import { Avatar, Grid, Container } from '@mui/material/'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { isNewExpression } from '@babel/types'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import { searchSchool } from '@util/helper'
import ManagerRegiPart from './manager-regi.part'
import ManagerRegiPartName from './manager-regi.part.name'
import ConfirmDialog from '@components/ConfirmDialog'
import ManagerRegiPartHistory from '@pages/manager/manager-regi.part.history'
import ManagerRegiPartPick from '@pages/manager/manager-regi.part.pick'
import useAlert from '@hooks/useAlert'
import { fetchSmst } from './manager-lecture.page'
import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined'
import * as ExcelJS from 'exceljs'

const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`

const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`

const RLTN_CODE = 'S003'
const ManagerBillPage = () => {
  console.log('ManagerBillPage rendering...')
  const g_sel_code = 'SA07'
  const g_stat_code = 'SA12'
  const g_week_code = 'SB07'

  const inputRef = useRef()
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const [detailScreen, set_detailScreen] = useState(false)
  const [isNew, set_isNew] = useState(false)
  const [schoolList, set_schoolList] = useState([])
  const [teacherList, set_teacherList] = useState([])
  const [smstList, set_smstList] = useState([])
  const [lessonList, set_lessonList] = useState([])
  const [lectureList, set_lectureList] = useState([])
  const [selCodeList, set_selCodeList] = useState([])
  const [statCodeList, set_statCodeList] = useState([])
  const [weekCodeList, set_weekCodeList] = useState([])
  const studentHeaders = ['학년', '반', '수강료', '강사료','수용비','교재비','재료비','보조인건비','기타비','합계' ]
  const lectureHeaders = ['강좌', '수강료', '강사료','수용비','교재비','재료비','보조인건비','기타비','합계', '취소자']
  const cancelHeaders = ['강좌', '학년', '반','번','이름', '취소일','합계']
  const theme = useTheme()

  const gubuns = [
    {gubun:-1, name: '선택'},
    {gubun:1, name: '강좌별'},
    {gubun:2, name: '학생(반)별'},
    {gubun:3, name: '취소자'},
  ]
  const fields = [
    { field: 'id', placeholder: '아이디', type: 'text', value: -1, visible: false, canSrch: false, selList: [] },
    {
      field: 'title',
      placeholder: '강좌명',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
    },
    {
      field: 'rcrNum',
      placeholder: '모집인원',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
    },
    {
      field: 'reqNum',
      placeholder: '신청인원',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
    },
    {
      field: 'sttNum',
      placeholder: '등록인원',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
    },
    {
      field: 'statName',
      placeholder: '상태',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
    },
  ]
  // const [fields, set_fields] = useState([...defFields])

  const gdnFields = [
    { field: 'name', placeholder: '성명' },
    { field: 'loginId', placeholder: 'ID' },
    { field: 'phone', placeholder: '전화번호' },
    { field: 'phoneCertYn', placeholder: '인증여부' },
  ]

  const getHeaders = () => {
    if(gubun == 1 ) {
      return lectureHeaders
    }
    else if(gubun == 2) {
      return studentHeaders
    }
    else if(gubun == 3) {
      return cancelHeaders
    }
    else {
      return []
    }
  }

  const visibleColumns = fields.filter((col) => col.visible)
  const defRecord = {}
  fields.forEach((d) => {
    defRecord[d.field] = d.value
  })
  defRecord.schoolList = []
  const defTerms = {}
  fields
    .filter((col) => col.canSrch)
    .map((d) => d.field)
    .forEach((d) => (defTerms[d] = ''))
  const [record, set_record] = useState(defRecord)
  const [dataList, set_dataList] = useState([])
  const [schoolGroup, set_schoolGroup] = useState([])

  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()
  const dgHandler = useState(false)
  const [selIdx, set_selIdx] = useState(-1)
  const [pageNum, set_pageNum] = useState(0)
  const [pageSize, set_pageSize] = useState(10)
  const [totalCount, set_totalCount] = useState(0)
  const [terms, _set_terms] = useState(defTerms)
  const [fontSize, set_fontSize] = useState(12)
  const [selStudentList, set_selStudentList] = useState([])
  const termsRef = useRef(terms)
  const [schoolRowSpan, set_schoolRowSpan] = useState({})
  const [openPay, set_openPay] = useState(false)
  const [openHistory, set_openHistory] = useState(false)
  const [openPick, set_openPick] = useState(false)
  // redux
  const codeGroups = useSelector((state) => state.codeGroupReducer)
  const codes = useSelector((state) => state.codeReducer)
  const schools = useSelector((state) => state.schoolReducer)
  const account = useSelector((state) => state.accountReducer)
  const schola = useSelector((state) => state.scholaReducer)
  const [smsts, set_smsts] = useState([])
  const [smst, set_smst] = useState({})
  const [billArray, set_billArray] = useState([])
  const [feeMap, set_feeMap] = useState({})
  const [totalSum, set_totalSum] = useState({})
  const [gubun, set_gubun] = useState(-1)
  const set_terms = (data) => {
    termsRef.current = data
    _set_terms(data)
  }

  const fetchBill = async () => {
    if(gubun == -1) {
      return
    } 
    let g= gubun
    if(gubun == 3)  {
      g = 1
    }

    const url = `/smst/export/bill/${smst.id}/${g}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const billArray = JSON.parse(repMessage.billArray)
    set_billArray(billArray)

    /*
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet(`${recordRef.current.year}_${recordRef.current.gisu}`)

    billArray.forEach((row, rowIdx) => {
      const formattedRow = row.map((value, colIdx) => {
        if (+gubun === 1 && rowIdx > 0 && colIdx >= 9 && colIdx<= 15) {
            return comma(value)
        } 
        else if (+gubun === 2 && rowIdx > 0 && colIdx >= 6 && colIdx<= 12) {
            return comma(value)
        } 
        else {
            return value;
        }
      })

      worksheet.addRow(formattedRow) 
    })
    
     
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' })
      let filename = `${schola.name}_${recordRef.current.year}_${recordRef.current.gisu}_결제정보`
      if(+gubun === 1) {
        filename = filename + `(강좌별)`
      }
      else if(+gubun === 2) {
        filename = filename + `(학생별)`
      }
      filename = filename + `.xlsx`

      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    });
    */ 
  }

  const fetchSmsts = async () => {
    const url = `/smst/${schola.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()

    if (resp.repCode != 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    return records
  }

  const fetchLectures = async () => {
    const url = `/regi/school/${schola.id}`
    const resp = await WebService.get(url)
    printVariable('resp', resp)
    if (resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      records.forEach((row) => {
        row.statName = findCode(codes, 'SA08', row.statCode)?.name ?? ''
      })

      return records
    } else {
      openSnackbar(resp.repMessage)
    }
  }

  const onLoad = async () => {
    const smsts = await fetchSmsts()
    console.log('smsts=>', smsts)
    set_smsts(smsts)
  }

  const calcFeeOfLectures = () => {
    const feeMap = 
      billArray.reduce((acc, cur, idx) => {
        if(idx != 0) {
          const key = `${cur[1]}`
          const map = acc[key]  || {
            sugang:0,
            gangsa:0,
            suyong:0,
            book:0,
            material:0,
            bojo:0,
            gita:0,
            sum:0,
            cancel:0,
          }

          map.sugang += +cur[10]
          map.gangsa+= +cur[11]
          map.suyong+= +cur[12]
          map.book += +cur[13]
          map.material += +cur[14]
          map.bojo+= +cur[15]
          map.gita+= +cur[16]
          map.sum += +cur[17]
          map.cancel += cur[18] == '취소' ? 1 : 0
          acc[key] = map
        }

        return acc
      }, {})

    //
    const totalSum = Object.values(feeMap).reduce((totals, current) => {
        totals.sugang += current.sugang;
        totals.gangsa += current.gangsa;
        totals.suyong += current.suyong;
        totals.book += current.book;
        totals.material += current.material;
        totals.bojo += current.bojo;
        totals.gita += current.gita;
        totals.sum += current.sum;
        totals.cancel += current.cancel;
        return totals;
      }, {
        sugang: 0,
        gangsa: 0,
        suyong: 0,
        book: 0,
        material: 0,
        bojo: 0,
        gita: 0,
        sum: 0,
        cancel: 0,
      }); 

    set_feeMap(feeMap)
    set_totalSum(totalSum)
    
  }

  const calcFeeOfSutdents = () => {
    const feeMap = 
      billArray.reduce((acc, cur, idx) => {
        if(idx != 0) {
          const key = `${cur[1]}@@@${cur[2]}`
          const map = acc[key]  || {
            sugang:0,
            gangsa:0,
            suyong:0,
            book:0,
            material:0,
            bojo:0,
            gita:0,
            sum:0,
          }

          map.sugang += +cur[6]
          map.gangsa+= +cur[7]
          map.suyong+= +cur[8]
          map.book += +cur[9]
          map.material += +cur[10]
          map.bojo += +cur[11]
          map.gita+= +cur[12]
          map.sum += +cur[13]
          acc[key] = map
        }

        return acc
      }, {})

    //
    const totalSum = Object.values(feeMap).reduce((totals, current) => {
        totals.sugang += current.sugang;
        totals.gangsa += current.gangsa;
        totals.suyong += current.suyong;
        totals.book += current.book;
        totals.material += current.material;
        totals.bojo += current.bojo;
        totals.gita += current.gita;
        totals.sum += current.sum;
        return totals;
      }, {
        sugang: 0,
        gangsa: 0,
        suyong: 0,
        book: 0,
        material: 0,
        bojo: 0,
        gita: 0,
        sum: 0,
      }); 

    set_feeMap(feeMap)
    set_totalSum(totalSum)

  }
 


  const calcCancels = () => {
    const cancels = billArray.filter(r => r.includes('취소'))
    // console.log('cancels=>', cancels)
    
    const feeMap = cancels.reduce((acc, cur, idx) => {
      if(cur.includes('취소')) {
        // console.log(`cancle  idx2:${idx}`)

      }
      // cur.forEach((item, idx2) => {
      //   console.log(`cancle item:${item} idx2:${idx2}`)
      // })
      if(idx != 0 && cur[18] == '취소') {
        const key = `${cur[1]}@@@${cur[2]}@@@${cur[3]}@@@${cur[4]}@@@${cur[5]}@@@${cur[8]}`
        const map = acc[key] || {
          sum: +cur[17]
        }
        acc[key] = map
      }

      return acc
    },{})

    const totalSum = Object.values(feeMap).reduce((totals, current) => {
        totals.sum += current.sum;
        return totals;
      }, {
        sum: 0,
      }); 

    set_feeMap(feeMap)
    set_totalSum(totalSum)
  }

  const handleDownload = () => {
    if(!smst.id || gubun === -1 )  {
      alert('데이터가 없습니다.')
      return
    }
    
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet(`${smst.year}_${smst.gisu}`)
    const excelHeader = ['년도/기수','강좌','학년', '반', '번호', '이름', '구분','신청일', '취소일', '휴강수강전일수', '수강료(a + b)', '강사료(a)', '수용비(b)', '교재비', '재료비', '보조인건비', '기타비', '계', '비고' ]
    const dataArray = (gubun == 1 || gubun == 2) ? [...billArray] : [...billArray.filter(r => r.includes('취소'))]
    if(gubun == 3) {
      dataArray.unshift(excelHeader)
    }
    dataArray.forEach((row, rowIdx) => {
      const formattedRow = row.map((value, colIdx) => {
        if (+gubun === 1 && rowIdx > 0 && colIdx >= 9 && colIdx<= 15) {
            return comma(value)
        } 
        else if (+gubun === 2 && rowIdx > 0 && colIdx >= 6 && colIdx<= 12) {
            return comma(value)
        } 
        else {
            return value;
        }
      })

      worksheet.addRow(formattedRow) 
    })
      
         
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' })
      let filename = `${schola.name}_${smst.year}_${smst.gisu}_결제정보`
      if(+gubun === 1) {
        filename = filename + `(강좌별)`
      }
      else if(+gubun === 2) {
        filename = filename + `(학생별)`
      }
      else if(+gubun === 3) {
        filename = filename + '(취소자)'
      }

      filename = filename + `.xlsx`

      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }); 
  }

  useEffect(() => {
    onLoad()
  },[])

  useEffect(() => {
    const size = window.getComputedStyle(inputRef.current, null).getPropertyValue('font-size')
    set_fontSize(size)
  }, [])

  useEffect(() => {
    if (smsts.length > 0) {
      set_smst(smsts[0])
    }
  }, [smsts])

  useEffect(() => {
    if(smst.id && gubun != -1) {
      fetchBill() 
    }
    else {
      set_billArray([])
    }
  }, [smst, gubun])

  useEffect(() => {
    if(billArray.length == 0 || gubun == -1) {
      set_feeMap({})
      set_totalSum({})
      return
    }

    if(gubun == 1) {
      calcFeeOfLectures()
    }
    else if(gubun == 2) {
      calcFeeOfSutdents()
    }
    else if(gubun == 3) {
      calcCancels()
    }
  }, [billArray])
  

  const dg_title = '수강신청 정보'
  const memo_DgContent = useMemo(() => {
    return <ManagerRegiPart />
  }, [record, detailScreen])

  if (dataList != null) {
    return (
      <div ref={inputRef}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <div style={{ paddingRight: 10, width: '100%' }}>
            <Grid container spacing={2} style={{ display: 'flex', alignItems: 'center' }}>
              <Grid item xs style={{}}>
                <h1>스쿨뱅킹</h1>
              </Grid>
              <Grid item xs={3}>
                <FormControl fullWidth>
                  <InputLabel id="gisu" size="small" sx={{ fontSize: '0.9em' }}>
                    기수
                  </InputLabel>
                  <Select
                    labelId="gisu"
                    label="기수"
                    size="small"
                    sx={{ fontSize: '0.9em' }}
                    value={smst}
                    onChange={(e) => {
                      set_smst(e.target.value)
                    }}
                  >
                    {smsts.map((s, index) => {
                      return (
                        <MenuItem key={index} value={s}>
                          {s.year}-{s.gisu}
                        </MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <FormControl fullWidth>
                  <InputLabel id="gubun" size="small" sx={{ fontSize: '0.9em' }}>
                    구분
                  </InputLabel>
                  <Select
                    labelId="gubun"
                    label="구분"
                    size="small"
                    sx={{ fontSize: '0.9em' }}
                    value={gubun}
                    onChange={(e) => {
                      set_gubun(e.target.value)
                    }}
                  >
                    {gubuns.map((item, index) => {
                      return (
                        <MenuItem key={index} value={item.gubun}>
                          {item.name} 
                        </MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <IconButton disabled={!smst.id || gubun == -1} onClick={handleDownload}>
                  <FileDownloadOutlined  size='large' /> 
                </IconButton>
                <Typography>상세내역다운로드</Typography>
              </Grid>
            </Grid>
          </div>
        </div>
        <div style={{marginBottom:10}}>
          <Typography color={theme.palette.secondary.main} >
              ※ 학기의 상태가 등록마감된 이후부터 데이터가 조회됩니다.
          </Typography>
        </div>
        <div style={{width:'100%' }} >
          <Grid container spacing={1} style={{backgroundColor:null}}>
            <Grid item xs={12}>
              <Grid container>
              {
                getHeaders().map((h, idx) => (
                  <Grid item xs key={idx}>
                    <Typography style={{fontWeight:'bold'}}>{h}</Typography>
                  </Grid>
                ))
              }

              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
                
                {
                  (!smst.id || gubun == -1) ?  (
                    <Typography variant='h6' textAlign={'center'}>
                      기수와 구분을 모두 선택해 주세요.
                    </Typography>
                  ) : 
                  Object.keys(feeMap).map((key, idx) => (
                    (() => {
                      const col= {}
                      /**
                        gubun 1: "ltite" 
                        gubun 2: "grade_ban_bun" 
                        gubun 3: "ltitle_grade_ban_bun_sname" 
                       * */
                      const splitted = key.split("@@@")
                      const ltitle= (gubun == 1 || gubun == 3)? splitted[0] : undefined
                      const grade = gubun == 2 ? splitted[0] : gubun == 3 ? splitted[1] : undefined
                      const ban = gubun == 2 ? splitted[1] : gubun == 3 ? splitted[2] : undefined
                      const bun = gubun == 3 ? splitted[3] : undefined
                      const sname = gubun == 3? splitted[4] : undefined
                      const cancelDate = gubun == 3? splitted[5] : undefined
                      const fee = feeMap[key]
                      col.ltitle = ltitle
                      col.grade = grade
                      col.ban = ban
                      col.bun = bun
                      col.sname = sname
                      col.cancelDate = cancelDate
                      Object.keys(fee).forEach(k => {
                        // if(k === 'sugang') {
                        //   console.log('sugang=>', fee[k])
                        // }
                        col[k] = comma(fee[k])
                      })

                      return(
                        <Grid container>
                          {
                            Object.keys(col).map((k2, idx2) => (
                              col[k2] != undefined? (
                                <Grid item xs key={idx2}>
                                  {/* { */}
                                  {/*   idx2 === 1 ? ( */}
                                  {/*     <Typography variant='body2'>{k2}</Typography> */}
                                  {/*   ) :( */}
                                  {/*     <Typography variant='body2'>{col[k2]}</Typography> */}
                                  {/*   ) */}
                                  {/* } */}
                                      <Typography variant='body2'>{col[k2]}</Typography>
                                </Grid>
                              ) : null

                            ))
                          }
                        </Grid> 
                      )
                    })()
                  ))
                }
            </Grid>
            <Grid item xs={12}>
              <Divider/>
            </Grid>
            {
              (smst.id && gubun != -1) ? (
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs>
                      <Typography style={{fontWeight:'bold'}} variant='body2'>계</Typography>
                    </Grid>
                    {
                      gubun == 2 ? (
                        <Grid item xs></Grid>
                      ) : gubun == 3 ? (
                        <>
                        <Grid item xs></Grid>
                        <Grid item xs></Grid>
                        <Grid item xs></Grid>
                        <Grid item xs></Grid>
                        <Grid item xs></Grid>
                        </>
                      ) : null
                    }
                    {

                      Object.values(totalSum).map((d, idx) => (
                        <Grid item xs key={idx}>
                          <Typography style={{fontWeight:'bold'}} variant='body2'>{comma(d)}</Typography>
                        </Grid>
                      ))
                    }
                  </Grid>      
                </Grid>

              ) : null
            }
          </Grid>
        </div>
        <div>
          {renderSnackbar()}
          {renderIndicator()}
          {renderAlert()}
        </div>
      </div>
    )
  }
}

export default ManagerBillPage
